import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle} from "domain-models"
import React from "react"
import {number, vehicleAttribute} from "../../../../../filters"
import Trans from '../../../../../components/Trans'

type VehicleOpticsProps = {
  vehicle: Vehicle
}

class VehicleOptics extends React.Component<VehicleOpticsProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon={['fas', 'eye']}/> <Trans>Aussehen</Trans>
        </span>

        <div className='flex flex-row flex-wrap w-full'>
          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Außenfarbe</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Color', vehicle.Color)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Herstellerfarbe</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.Miscellaneous}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Innenfarbe</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Interior', vehicle.Interior)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Ausstattungslinie</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('EquipmentLine', vehicle.EquipmentLine)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Sitzbezüge</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('SeatCover', vehicle.SeatCover)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Türen</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.NumDoors, 0)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Sitze</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.NumSeats, 0)}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default VehicleOptics
